@let showCommunication =
	recordData().contactEmail ||
	recordData().contactPhoneMobile ||
	recordData().contactPhoneFax ||
	recordData().contactPhoneLandline;

@let showAddress =
	recordData().contactAddress1 ||
	recordData().contactAddress2 ||
	recordData().contactCity ||
	recordData().contactPostCode ||
	recordData().contactCounty ||
	recordData().contactState ||
	recordData().contactCountryId ||
	recordData().contactPoBox;

@let showContactInfo =
	recordData().contactFirstName ||
	recordData().contactLastName ||
	recordData().contactCompanyName ||
	recordData().contactMiddleNames;

<app-section-wrapper-container [title]="'contact-card|title'">
	@if (showContactInfo) {
		<div class="overview-sub-section">
			@if (recordData().contactFirstName || recordData().contactLastName) {
				<app-summary-item
					[title]="'contact-card|name'"
					[value]="
						(recordData().contactFirstName ?? '') +
						' ' +
						(recordData().contactLastName ?? '')
					"></app-summary-item>
			}

			@if (recordData().contactCompanyName) {
				<app-summary-item
					[title]="'contact-card|company-name'"
					[value]="recordData().contactCompanyName"></app-summary-item>
			}

			@if (recordData().contactMiddleNames) {
				<app-summary-item
					[title]="'contact-card|middleNames'"
					[value]="recordData().contactMiddleNames"></app-summary-item>
			}

			@if (recordData().contactDateOfBirth) {
				<app-summary-item
					[title]="'contact-card|date-of-birth'"
					[value]="
						recordData().contactDateOfBirth | date: 'dd MMM yyyy'
					"></app-summary-item>
			}
		</div>
	}

	@if (showCommunication) {
		<div class="overview-sub-section">
			@if (recordData().contactEmail) {
				<app-summary-item
					[title]="'contact-card|email'"
					[value]="recordData().contactEmail"></app-summary-item>
			}

			@if (recordData().contactPhoneMobile) {
				<app-summary-item
					[title]="'contact-card|phone-mobile'"
					[value]="recordData().contactPhoneMobile"></app-summary-item>
			}

			@if (recordData().contactPhoneFax) {
				<app-summary-item
					[title]="'contact-card|phone-fax'"
					[value]="recordData().contactPhoneFax"></app-summary-item>
			}

			@if (recordData().contactPhoneLandline) {
				<app-summary-item
					[title]="'contact-card|phone-landline'"
					[value]="recordData().contactPhoneLandline"></app-summary-item>
			}
		</div>
	}
	@if (showAddress) {
		<div class="overview-sub-section">
			@if (recordData().contactAddress1) {
				<app-summary-item
					[title]="'contact-card|address1'"
					[value]="recordData().contactAddress1"></app-summary-item>
			}

			@if (recordData().contactAddress2) {
				<app-summary-item
					[title]="'contact-card|address2'"
					[value]="recordData().contactAddress2"></app-summary-item>
			}

			@if (recordData().contactCity) {
				<app-summary-item
					[title]="'contact-card|city'"
					[value]="recordData().contactCity"></app-summary-item>
			}

			@if (recordData().contactPostCode) {
				<app-summary-item
					[title]="'contact-card|post-code'"
					[value]="recordData().contactPostCode"></app-summary-item>
			}

			@if (recordData().contactCounty) {
				<app-summary-item
					[title]="'contact-card|county'"
					[value]="recordData().contactCounty"></app-summary-item>
			}

			@if (recordData().contactState) {
				<app-summary-item
					[title]="'contact-card|state'"
					[value]="recordData().contactState"></app-summary-item>
			}

			@if (recordData().contactCountryId) {
				<app-summary-item
					[title]="'contact-card|country'"
					[value]="
						recordData().contactCountryId | countryName
					"></app-summary-item>
			}

			@if (recordData().contactPoBox) {
				<app-summary-item
					[title]="'contact-card|po-box'"
					[value]="recordData().contactPoBox"></app-summary-item>
			}
		</div>
	}
</app-section-wrapper-container>
